"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageName = void 0;
exports.packageName = "@lsos/donation-reminder";
if (isNodejs()) {
    assertPackageName();
}
function assertPackageName() {
    var assert = lazyRequire("assert");
    var packageJson = lazyRequire("../../package.json");
    var packageName2 = packageJson.name;
    assert(exports.packageName === packageName2);
}
function isNodejs() {
    return typeof window === "undefined";
}
function lazyRequire(id) {
    return eval("require")(id);
}
//# sourceMappingURL=packageName.js.map